import { useState } from "react";
import { useTranslate } from "ra-core";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { todayInput } from "./nextAction";

// Asked when a deal without a next action goes to an open stage: the
// database refuses an open deal without one (task 1.8, D-037). A date in
// the past is accepted. Cancel leaves the deal where it was.
export const NextActionDialog = ({
  dealName,
  onConfirm,
  onCancel,
}: {
  dealName?: string;
  onConfirm: (day: string) => void;
  onCancel: () => void;
}) => {
  const translate = useTranslate();
  const [day, setDay] = useState(todayInput());

  return (
    <Dialog open onOpenChange={(open) => !open && onCancel()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            {translate("tenax.deals.next_action.title")}
          </DialogTitle>
          <DialogDescription>
            {dealName
              ? translate("tenax.deals.next_action.hint_deal", {
                  name: dealName,
                })
              : translate("tenax.deals.next_action.hint")}
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col gap-2">
          <Label htmlFor="tenax-next-action">
            {translate("resources.deals.fields.next_action_at")}
          </Label>
          <Input
            id="tenax-next-action"
            type="date"
            value={day}
            onChange={(event) => setDay(event.target.value)}
          />
        </div>
        <DialogFooter>
          <Button type="button" variant="outline" onClick={onCancel}>
            {translate("ra.action.cancel")}
          </Button>
          <Button type="button" disabled={!day} onClick={() => onConfirm(day)}>
            {translate("tenax.deals.next_action.confirm")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
